import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ajaxGetDictItems } from '@/api/api';
export default {
  name: 'JDictSelectTag',
  props: {
    size: String,
    dictCode: String,
    placeholder: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number],
    type: String,
    search: Boolean,
    initData: {
      type: Boolean,
      default: true
    },
    defaultState: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: ''
    },
    dataOptions: Array,
    mode: String
  },
  data: function data() {
    return {
      dictOptions: [],
      tagType: ''
    };
  },
  watch: {
    dictCode: function dictCode() {
      this.initDictData();
    }
  },
  created: function created() {
    if (!this.type || this.type === 'list') {
      this.tagType = 'select';
    } else {
      this.tagType = this.type;
    } //获取字典数据


    this.initDictData();
  },
  methods: {
    initDictData: function initDictData() {
      var _this = this;

      if (this.initData && this.dictCode) {
        //根据字典Code, 初始化字典数组
        ajaxGetDictItems(this.dictCode, null).then(function (res) {
          if (res.success) {
            _this.dictOptions = res.result;

            if (!_this.value && _this.defaultState) {
              _this.value = _this.dictOptions[0].value; // 修改部分  在使用默认值时返回给父组件对应的默认值

              if (_this.triggerChange) {
                _this.$emit('change', _this.value);
              } else {
                _this.$emit('input', _this.value);
              }
            }
          }
        });
      } else {
        console.log('dataOptions', this.dataOptions);
        this.dictOptions = this.dataOptions;

        if (!this.value && this.defaultState) {
          this.value = this.dictOptions[0].value; // 修改部分  在使用默认值时返回给父组件对应的默认值

          if (this.triggerChange) {
            this.$emit('change', this.value);
          } else {
            this.$emit('input', this.value);
          }
        }
      }
    },
    handleInput: function handleInput(e) {
      console.log(e);
      var val;

      if (this.tagType == 'radio') {
        val = e.target.value;
      } else {
        val = e;
      }

      if (this.triggerChange) {
        this.$emit('change', val);
      } else {
        this.$emit('input', val);
      }
    },
    setCurrentDictOptions: function setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions;
    },
    getCurrentDictOptions: function getCurrentDictOptions() {
      return this.dictOptions;
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};